/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import{registerCheckList as o}from"@lexical/list";import{useLexicalComposerContext as r}from"@lexical/react/LexicalComposerContext";import{useEffect as t}from"react";function e(){const[e]=r();return t((()=>o(e)),[e]),null}export{e as CheckListPlugin};
